import moment from 'moment';

const getDateDiff = (date1, date2) => moment(date2).diff(moment(date1));

export default getDateDiff;
